<div class="spinner-container" [style]="{'align-items': horizontalPosition, 'justify-content': verticalPosition}">
    <mat-spinner class="loading-spinner" [diameter]="size" [strokeWidth]="size / 12" color="primary"></mat-spinner>
</div>
